import { render } from "./MultipleMyelomaView.vue?vue&type=template&id=65a9dc4a"
import script from "./MultipleMyelomaView.vue?vue&type=script&lang=js"
export * from "./MultipleMyelomaView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__